import { mapValues } from "lodash";
import { bindActionCreators } from "redux";

import screenModes from "../constants/screenModes";

const mergeDispatchToProps = (readOnlyActions, editingActions, dispatch) => {
  let result = null;
  //#!if readonly === true
  result = {
    ...mapValues(editingActions, _a => () => {}),
    ...bindActionCreators(readOnlyActions, dispatch)
  };
  //#!else
// result = {
// ...bindActionCreators(Object.assign(readOnlyActions, editingActions), dispatch)
// };
  //#!endif
  return result;
};

const mergeDispatchToPropsWithExtraProps = (getReadonlyActions, getEditingActions, props, dispatch) => {
  let result = null;
  const readonlyActions = getReadonlyActions(props, dispatch);
  const editingActions = getEditingActions(props, dispatch);
  //#!if readonly === true
  result = {
    ...readonlyActions,
    ...mapValues(editingActions, _a => () => {})
  };
  //#!endif
  result = { ...Object.assign(readonlyActions, editingActions) };
  return result;
};

const mergeEditingObject = (readonlyObj, editingObj) => {
  let result = readonlyObj;
  //#!if readonly !== true
// result = Object.assign(result, editingObj);
  //#!endif
  return result;
};

const chooseObjectForReadonly = (readonlyObj, normalObj) => {
  let result = null;
  //#!if readonly === true
  result = readonlyObj;
  //#!else
// result = normalObj;
  //#!endif
  return result;
};

const filterReadonlyMenus = (readonlyMenuTypes, menulist) => {
  let result = null;
  //#!if readonly !== true
// result = menulist;
  //#!else
  result = menulist.filter(m => readonlyMenuTypes.includes(m.messageType));
  //#!endif
  return result;
};

const wrapEditingComponent = com => {
  let result = null;
  //#!if readonly !== true
// result = com;
  //#!endif
  return result;
};

const showOnExtraConditionForReadonly = (obj, condition) => {
  let result = obj;
  //#!if readonly === true
  result = condition ? result : null;
  //#!endif
  return result;
};

const disableWhenIos = com => {
  let result = null;
  //#!if iOS !== true
  result = com;
  //#!endif
  return result;
};

const chooseValueForIos = (iosValue, normalValue) => {
  let result = normalValue;
  //#!if iOS === true
// result = iosValue;
  //#!endif
  return result;
};

const disableWhenTablet = com => {
  let result = null;
  //#!if tablet !== true
  result = com;
  //#!endif
  return result;
};

const chooseValueForTablet = (tabletValue, normalValue) => {
  let result = normalValue;
  //#!if tablet === true
// result = tabletValue;
  //#!endif
  return result;
};

const chooseValueForHarvard = (harvardValue, normalValue) => {
  let result = normalValue;
  //#!if harvard === true
  result = harvardValue;
  //#!endif
  return result;
};

const getIsMobile = props => props.screenContext && props.screenContext.screenMode === screenModes.MobilePortrait;

export {
  chooseObjectForReadonly,
  chooseValueForHarvard,
  chooseValueForIos,
  chooseValueForTablet,
  disableWhenIos,
  disableWhenTablet,
  filterReadonlyMenus,
  getIsMobile,
  mergeDispatchToProps,
  mergeDispatchToPropsWithExtraProps,
  mergeEditingObject,
  showOnExtraConditionForReadonly,
  wrapEditingComponent
};
